export enum bannerPreviewType {
    HERO = 'hero',
    HERO_WITH_TWO_SMALL = 'herowithtwosmall',
    IMAGE_FULL_WIDTH = 'imagefullwidth',
    IMAGE_HALF_WIDTH = 'Imagehalfwidth',
    PRODUCT_LIST = 'productlistpage',
    PRODUCT_DETAILS = 'productdetailspage',
    BASKET = 'basket',
    RESOURCE_MENU = 'resourcemenu'
}
